import { ModalAngelopolis } from "./ModalAngelopolis";
import { ZoneModalInfo } from "./ZoneInfoModal";

import iconAmenidadPArk from "../../assets/images/amenidades.png";
//
import cascatta1 from "../../assets/images/zones/cascatta-1.png";
import cascatta2 from "../../assets/images/zones/cascatta-2.png";
import cityLomas from "../../assets/images/zones/city-lomas.jpg";
import downto from "../../assets/images/zones/downtownpuebla.jpeg";
import lomas2 from "../../assets/images/zones/lomas-2.jpeg";
import sonata from "../../assets/images/zones/sonata.jpg";
import zonaAzul from "../../assets/images/zones/zona-azul.png";
// icons
import park from "../../assets/images/iconsAmenidades/icono-v2-color_parques.png";
import zonesicons from "../../assets/images/iconsAmenidades/icono-v2-Zonas.png";
import hipico from "../../assets/images/iconsAmenidades/icono-v2-color_hipico.png";
import pet from "../../assets/images/iconsAmenidades/icono-v2-color_mascotas.png";
import school from "../../assets/images/iconsAmenidades/icono-v2-color_escuela.png";
import store from "../../assets/images/iconsAmenidades/icono-v2-color_comercial.png";
import cascada from "../../assets/images/iconsAmenidades/icono-v2-color_cascada.png";
import house from "../../assets/images/iconsAmenidades/icono-house.png";

// Caballos
import caballoUno from "../../assets/images/amenidad/caballo/caballo-uno.jpg";
import caballoDos from "../../assets/images/amenidad/caballo/caballo-dos.jpg";
import caballoTres from "../../assets/images/amenidad/caballo/caballo-tres.jpg";

// Casa club
import casaClubUno from "../../assets/images/amenidad/casaclub/club-1.jpg";
import casaClubDos from "../../assets/images/amenidad/casaclub/club-2.jpg";
import casaClubTres from "../../assets/images/amenidad/casaclub/club-3.jpg";

// Cascada
import cascadaUno from "../../assets/images/amenidad/cascada/cascada-uno.jpg";
import cascadaDos from "../../assets/images/amenidad/cascada/cascada-dos.jpg";
import cascadaTres from "../../assets/images/amenidad/cascada/cascada-tres.jpg";
import cascadaFour from "../../assets/images/amenidad/cascada/cascada-cuatro.jpg";
import cascadaFive from "../../assets/images/amenidad/cascada/cascada-cinco.jpg";
import cascadaSix from "../../assets/images/amenidad/cascada/cascada-seis.jpg";
import cascadaSeven from "../../assets/images/amenidad/cascada/cascada-seven.jpg";
import cascadaEight from "../../assets/images/amenidad/cascada/cascada-ocho.jpg";

// Comercial
import comercialUno from "../../assets/images/amenidad/comercial/comercial-1.jpg";
import comercialDos from "../../assets/images/amenidad/comercial/comercial-2.jpg";
import comercialTres from "../../assets/images/amenidad/comercial/comercial-3.jpg";

// Escolar
import escolarUno from "../../assets/images/amenidad/escolar/escolar-uno.jpg";
import escolarDos from "../../assets/images/amenidad/escolar/escolar-tres.jpg";
import escolarTres from "../../assets/images/amenidad/escolar/escolar-cuatro.jpg";
import escolarfour from "../../assets/images/amenidad/escolar/escolar-cinco.jpg";

// Parque
import parqueUno from "../../assets/images/amenidad/parque/parque-uno.jpg";
import parqueDos from "../../assets/images/amenidad/parque/parque-dos.jpg";
import parqueTres from "../../assets/images/amenidad/parque/parque-tres.jpg";
import parqueFour from "../../assets/images/amenidad/parque/parque-4.jpeg";
import parqueFive from "../../assets/images/amenidad/parque/parque-5.jpeg";
import parqueSix from "../../assets/images/amenidad/parque/parque-cinco.jpg";

// Mascota
import mascotaUno from "../../assets/images/amenidad/mascota/mascota-uno.jpg";
import mascotaDos from "../../assets/images/amenidad/mascota/mascota-tres.jpg";
import mascotaTres from "../../assets/images/amenidad/mascota/mascota-seis.jpg";
import mascota4 from "../../assets/images/amenidad/mascota/mascota-cuatro.jpg";
import mascotaCuatro from "../../assets/images/amenidad/mascota/mascota-cuatro.jpg";

export class ModalInfoAmenidades {
  constructor() {
    // define singleton intance
    if (ModalInfoAmenidades.instance) {
      return ModalInfoAmenidades.instance;
    }
    ModalInfoAmenidades.instance = this;
    this.mapOfIcons = [];
    this.intiMapOfNames();
    this.modalAngelopolis = new ModalAngelopolis();
    this.modalzone = new ZoneModalInfo();
    this.htmlElement = document.querySelector("#modalAmenidades");
    this.iconCloseModalAmenidades = document.querySelector(
      "#iconCloseModalAmenidades"
    );
    this.descriptionAmenidad = document.querySelector("#descriptionAmenidad");
    this.nameAmenidad = document.querySelector("#nameAmenidad");
    this.iconAmenidad = document.querySelector("#iconAmenidad");
    this.amenidadImg1 = document.querySelector("#amenidadImg1");
    this.amenidadImg2 = document.querySelector("#amenidadImg2");
    this.amenidadImg3 = document.querySelector("#amenidadImg3");
    this.amenidadImg4 = document.querySelector("#amenidadImg4");
    this.amenidadImg5 = document.querySelector("#amenidadImg5");
    this.amenidadImg6 = document.querySelector("#amenidadImg6");
    this.actualPositionImg = 1;
    this.imagesCarrousel = [];
    this.carrusel = [
      this.amenidadImg1,
      this.amenidadImg2,
      this.amenidadImg3,
      this.amenidadImg4,
      this.amenidadImg5,
      this.amenidadImg6,
    ];
    this.highlight = document.querySelector("#gallery-hightlight");
    this.previews = document.querySelectorAll("#room-preview");
    this.initListeners();
  }
  // I_bosque1_MT_G_iconos_0
  showModal(iconName = "") {
    this.actualPositionImg = 1;
    if (iconName !== "") {
      const infoModal = this.mapOfIcons.find((icon) => {
        const isFinde = icon.nameIcon.find((name) => name === iconName);
        if (isFinde) {
          return icon;
        } else {
          return null;
        }
        //icon.nameIcon === iconName
      });
      if (infoModal.entryTitle) {
        this.modalAngelopolis.hideModal();
        this.modalzone.showModal(
          infoModal.entryTitle,
          false,
          infoModal.entrySubtitle
        );
      } else {
        this.iconAmenidad.src = infoModal.icon;
        this.nameAmenidad.innerText = infoModal.title;
        this.descriptionAmenidad.innerHTML = infoModal.description;
        this.highlight.src = infoModal.pricipalImg;
        this.imagesCarrousel = infoModal.images;
        this.carrusel.map((container, index) => {
          if (infoModal.images[index]) {
            container.src = infoModal.images[index];
            if (container.classList.contains("hidden")) {
              container.classList.replace("hidden", "flex");
            }
          } else {
            if (container.classList.contains("flex")) {
              container.classList.replace("flex", "hidden");
            }
          }
        });

        if (this.htmlElement.classList.contains("hidden")) {
          this.htmlElement.classList.replace("hidden", "flex");
          this.modalAngelopolis.hideModal();
          this.modalzone.hideModal();
        }
      }
    }
  }

  hideModal() {
    if (this.htmlElement.classList.contains("flex")) {
      this.htmlElement.classList.replace("flex", "hidden");
    }
  }

  initListeners() {
    this.iconCloseModalAmenidades.addEventListener("click", () => {
      this.hideModal();
    });

    this.carrusel.map((elementCarrusel) => {
      elementCarrusel.addEventListener("click", () => {
        this.highlight.src = elementCarrusel.src;
      });
    });
  }

  intiMapOfNames() {
    this.mapOfIcons = [
      {
        nameIcon: [
          "I_bosque1_MT_G_iconos_0",
          "I_bosque7_MT_G_iconos_0",
          "I_bosque6_MT_G_iconos_0",
          "I_bosque2_MT_G_iconos_0",
          "I_bosque24_MT_G_iconos_0",
          "I_bosque23_MT_G_iconos_0",
          "I_bosque22_MT_G_iconos_0",
          "I_bosque21_MT_G_iconos_0",
          "I_bosque3_MT_G_iconos_0",
          "I_bosque4_MT_G_iconos_0",
          "I_bosque5_MT_G_iconos_0",
          "I_bosque8_MT_G_iconos_0",
          "I_bosque9_MT_G_iconos_0",
          "I_bosque10_MT_G_iconos_0",
          "I_bosque11_MT_G_iconos_0",
          "I_bosque12_MT_G_iconos_0",
          "I_bosque8_MT_G_iconos_0",
          "I_bosque13_MT_G_iconos_0",
          "I_bosque14_MT_G_iconos_0",
          "I_bosque15_MT_G_iconos_0",
          "I_bosque16_MT_G_iconos_0",
          "I_bosque17_MT_G_iconos_0",
          "I_bosque18_MT_G_iconos_0",
          "I_bosque19_MT_G_iconos_0",
          "I_bosque20_MT_G_iconos_0",
        ],
        title: "Parques",
        icon: park,
        description: `
                Vivir en Lomas de Angelópolis es alejarse del bullicio de la ciudad para priorizar un entorno natural. <br> 
                Nuestros parques y áreas verdes tienen:
                ciclopistas y pistas para correr, lagos y cascadas complementando el paisaje, áreas infantiles y muchas cosas más.
                `,
        pricipalImg: parqueUno,
        images: [
          parqueUno,
          parqueDos,
          parqueTres,
          parqueFour,
          parqueFive,
          parqueSix,
        ],
      },
      {
        nameIcon: ["I_caballos_MT_G_iconos_0"],
        title: "Hípico",
        icon: hipico,
        description: `
                Nuestro Centro Ecuestre tiene los recursos necesarios para ofrecer experiencias inolvidables a cualquier persona interesada por el trabajo y deporte al lado de esos majestuosos animales.
                `,
        pricipalImg: caballoUno,
        images: [caballoUno, caballoDos, caballoTres],
      },
      {
        nameIcon: ["I_Escolar_MT_G_iconos_0"],
        title: "Escolar",
        icon: school,
        description: `
                Lomas Angelópolis es el lugar más seguro para ti y tu familia. Ofrece una ubicación privilegiada con acceso a todo tipo de servicios incluidos educativos de todos los niveles y de la más alta calidad.
                `,
        pricipalImg: escolarUno,
        images: [escolarUno, escolarDos, escolarTres, escolarfour],
      },
      {
        nameIcon: ["I_cascadas_MT_G_iconos_0"],
        title: "Cascada",
        icon: cascada,
        description: `
                Lomas de Angelópolis piensa en cada detalle y busca brindar espacios estéticos que 
                contribuyan al bienestar personal de cada miembro de la comunidad ofreciendo espacios
                 con atento diseño de paisaje y entorno.
                `,
        pricipalImg: cascadaUno,
        images: [
          cascadaUno,
          cascadaDos,
          cascadaTres,
          cascadaFour,
          cascadaFive,
          cascadaSix,
          cascadaSeven,
          cascadaEight,
        ],
      },
      {
        nameIcon: ["I_veterinario_MT_G_iconos_0"],
        title: "Parque de mascotas",
        icon: pet,
        description: `
                Sabemos que tu mascota es parte fundamental de la familia. Lomas de Ángelopolis cuenta con espacios especializados para proporcionar 
                el bienestar más óptimo de tu mascota.
                `,
        pricipalImg: mascotaUno,
        images: [mascotaUno, mascotaDos, mascota4, mascotaTres],
      },
      {
        nameIcon: [
          "I_Parque_MT_G_iconos_0",
          "I_casaClub_fontana_MT_G_iconos_0",
          "I_casaClub_balcanes",
          "I_casaClub_sacramento_MT_G_iconos_0",
          "I_casaClub_arcadia_MT_G_iconos_0",
          "I_casaClub_rinconada_MT_G_iconos_0",
          "I_casaClub_capri_MT_G_iconos_0",
          "I_casaClub_galena_MT_G_iconos_0",
          "I_casaClub_antalya",
          "I_casaClub_bali_MT_G_iconos_0",
          "I_casaClub_creta_MT_G_iconos_0",
          "I_casaClub_rodas_MT_G_iconos_0001",
          "I_casaClub_rodas_MT_G_iconos_0",
          "I_casaClub_vilansa_MT_G_iconos_0",
          "I_casaClub_anturio_MT_G_iconos_0",
          "I_casaClub_parqueBerna_MT_G_iconos_0",
          "I_casaClub_sofia_MT_G_iconos_0",
          "I_casaClub_parqueViena_MT_G_iconos_0",
          "I_casaClub_palermo_MT_G_iconos_0",
          "I_casaClub_verona",
          "I_casaClub_verona002",
          "I_casaClub_verona001",
          "I_casaClub_bali",
          "I_casaClub_lucerna",
          "I_casaClub_zante",
          "I_casaClub_Siena",
          "I_casaClub_lacantera",
          "I_casaClub_Ferrara",
          "I_casaClub_Montenegro",
        ],
        title: "Casa club",
        icon: house,
        description: `
                En tu cluster, además de tu lote, encontrarás una casa club en donde podrás disfrutar de diversos espacios recreativos siempre a tu disposición.
                `,
        pricipalImg: casaClubUno,
        images: [casaClubUno, casaClubDos, casaClubTres],
      },
      {
        nameIcon: [
          "I_barrioCascatta_MT_G_iconos_0",
          "I_Parque_MT_G_iconos_0",
          "I_sonata_MT_G_iconos_0",
          "I_downtownPuebla_MT_G_iconos_0",
        ],
        title: "Centro comercial",
        icon: store,
        description: `
                No importa tu antojo o necesidad, tenemos todo lo que buscas disponible sin que tengas que salir de Lomas. Desde servicios de salud, bienestar, belleza y entretenimiento hasta tiendas, bancos, restaurantes y bares.                  
                `,
        pricipalImg: comercialUno,
        images: [comercialUno, comercialDos, comercialTres],
      },
      {
        nameIcon: ["I_lomas1_MT_G_iconos_0"],
        icon: zonesicons,
        title: "Lomas I",
        description: `Una de las primeras secciones en ser desarrollada en Lomas de Angelópolis. En ella encontrarás servicios, comercios y varias amenidades para garantizar tu bienestar y la experiencia más completa. `,
        pricipalImg: cityLomas,
        images: [cityLomas],
      },
      {
        nameIcon: ["I_lomas2_MT_G_iconos_0"],
        icon: zonesicons,
        title: "Lomas II",
        description: `Una de las primeras secciones en ser desarrollada en Lomas de Angelópolis. En ella encontrarás servicios, comercios y varias amenidades para garantizar tu bienestar y la experiencia más completa. `,
        pricipalImg: lomas2,
        images: [lomas2],
      },
      {
        nameIcon: ["I_zonaAzul_MT_G_iconos_0"],
        icon: zonesicons,
        title: "Zona azul",
        description: `Zona rodeada de parques y paisajismo, muy cerca del distrito escolar y las secciones con zonas comerciales.`,
        pricipalImg: zonaAzul,
        images: [zonaAzul],
      },
      {
        nameIcon: ["I_cascatta_MT_G_iconos_0"],
        icon: zonesicons,
        title: "Cascatta",
        description: ` Un gran centro urbano que alberga desarrollos de departamentos, comercios, corporativos, 
                así como servicios de primer nivel. El diseño de Barrio Cascatta es el equilibrio perfecto entre 
                naturaleza y urbanismo, el cual está integrado por un extenso parque central.
                `,
        pricipalImg: cascatta2,
        images: [cascatta1, cascatta2],
      },
      {
        nameIcon: ["I_acceso1_MT_G_iconos_0"],
        entryTitle: "Acceso por Cascadasa",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_acceso2_MT_G_iconos_0"],
        entryTitle: "Acceso Toscana",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_Ferrara"],
        entryTitle: "Acceso Ferrara",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_Siena"],
        entryTitle: "Acceso Siena",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_antalya"],
        entryTitle: "Acceso antalya",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_creta_MT_G_iconos_0"],
        entryTitle: "Acceso Creta",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_bali"],
        entryTitle: "Acceso Bali",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_fontana_MT_G_iconos_0"],
        entryTitle: "Acceso Fontana",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_sacramento_MT_G_iconos_0"],
        entryTitle: "Acceso Sacramento",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_arcadia_MT_G_iconos_0"],
        entryTitle: "Acceso Arcadia",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_galena_MT_G_iconos_0"],
        entryTitle: "Acceso Galena",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_rinconada_MT_G_iconos_0"],
        entryTitle: "Acceso Rinconada",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_lucerna"],
        entryTitle: "Acceso Lucerna",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_lacantera"],
        entryTitle: "Acceso La cantera",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_Milos"],
        entryTitle: "Acceso Milos",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_TerraVerde"],
        entryTitle: "Acceso Terra Verde",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_Montenegro"],
        entryTitle: "Acceso Montenegro",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_balcanes"],
        entryTitle: "Acceso Balcanes",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_niza"],
        entryTitle: "Acceso Niza",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_acceso3_MT_G_iconos_0"],
        entryTitle: "Acceso Sonata",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_galena_MT_G_iconos_0001"],
        entryTitle: "Acceso Verona",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_galena_MT_G_iconos_0002"],
        entryTitle: "Acceso Sorrento",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_zante"],
        entryTitle: "Acceso",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_rodas_MT_G_iconos_0001"],
        entryTitle: "Acceso Bali",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
      {
        nameIcon: ["I_caseta_galena_MT_G_iconos_0003"],
        entryTitle: "Acceso Trento",
        entrySubtitle: "",
        icon: "",
        title: "entry",
        description: ` .
                `,
        pricipalImg: "",
        images: ["", ""],
      },
    ];
  }
}
